
define('text!templates/appMain/privilegedMain/supervisorDetailsView.html',[],function () { return '<!-- ko include: {\n    name: \'templates/appMain/privilegedMain/detailsContainerView\',\n    data: detailsContainerView\n} -->\n<!-- /ko -->';});

